export class VendorHeaderTemplateRawDto {
    specialHandlingId: number;
    description: string;
    bankAccountId: number; // 	NOTE: This is used when verifying or approving work flow
}
